module.exports = __webpack_public_path__ + "static/media/3.7a1588d3.jpg";